import React from 'react';
import styles from './timerReminderPopup.module.sass';
import { useDispatch, useSelector } from 'react-redux';
import getSkin from './skin.js';
import { css } from 'aphrodite/no-important';
import applyWrappers from 'wrappers/ComponentWrapper';
import HurryUp from 'svgComponents/hurryUp';

import { gameStarted } from 'actions/apiActions/gameStarted';

import analyticsUtil from 'util/analyticsUtil';

const TimerReminder= (props) => {

	const myStyles = getSkin(props.skinGuide);
	const dispatch = useDispatch();
	const myProps = useSelector((state) => {
		return {
			uiState: state.uiState
		};
	});

	const onTimerReminderPopupClick = (e) => {
		e.stopPropagation();
	}

	const closePopup = () => {
		analyticsUtil.track('POPUP_CLOSED', { popup: myProps.uiState.overlayComponent, type: myProps.uiState.overlayComponentType });

		dispatch({
			type: 'UPDATE_UI_STATE',
			payload: {
				showOverlay: false,
				overlayComponentType: '',
				highlightDesktopHeader: false,
				overlayComponent: ''
			}
		});
	}

	return (
		<div className={css(myStyles.startSimPopupContainer)} styleName="startSimPopup-container" onClick={onTimerReminderPopupClick}>
			<div styleName="content-container">
				<div styleName="content-details">
					<div styleName="advisor-details">
						<div styleName="advisor-image">
							<HurryUp/>
						</div>
					</div>
					<div className={css(myStyles.advisorHeading)} styleName="advisor-desc">
						{ props.getLabel("label_timer_notification_title") }
					</div>
					<div className={css(myStyles.advisorDesc)} styleName="advisor-desc">
						{ props.getLabel("label_timer_notification_desc") }
					</div>
					<div styleName="button-container">
						<div className={css(myStyles.startButton)} styleName="button" onClick={closePopup}>
							{ props.getLabel("label_timer_notification_cta") }
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default applyWrappers(TimerReminder, styles);
